import resume from '../assets/pdf/resume.pdf'
import portrait from '../assets/jpg/portrait.jpg'

export const headerData = {
    name: 'Piotr Kałmuczak',
    title: "Software Engineer",
    desciption:"Hi! My name's Piotr and I'm a software engineer graduated from University of Wroclaw in the field of computer science with 3 years of commercial experience. Also, a rustacean🦀",
    image: portrait,
    resumePdf: resume
}
